(function() {
    angular.module('tmx-app').controller('operationReportCtrl', [
        '$mdSidenav',
        'tmxUtility',
        'menu',
        '$mdMedia',
        'BranchService',
        'OperationReportService',

        function OperationReportCtrl(
            $mdSidenav,
            tmxUtility,
            menu,
            $mdMedia,
            BranchService,
            OperationReportService
        ) {
            var operationReportVM = this;
            operationReportVM.menu = menu;
            operationReportVM.gridData = new kendo.data.ObservableArray([]);
    // operationReportVM.checkPermission = PrivilegesService.checkPermission;
            operationReportVM.search = search;
            operationReportVM.filterEnabled = false;
    // operationReportVM.disableExport = true;
            operationReportVM.toggle = toggle;
            operationReportVM.isOpen = isOpen;
            var exportLoanApplicationNumber = null;
            var exportBranchId = null;
            var exportNationalId=null;
            var exportFromDate=null;
            var exportToDate=null;
    
            operationReportVM.clear = clear;
            operationReportVM.formatColumnName = tmxUtility.formatColumnName;
            operationReportVM.formatDateTime=tmxUtility.formatDateTimeForCompany;            


            function isOpen(navID) {
                return $mdSidenav(navID).isOpen();
            }
            function clear() {
    //   operationReportVM.disableExport = true;
                operationReportVM.LoanApplicationNumber = null;
                operationReportVM.BranchId=null;
                operationReportVM.NationalId=null;
                operationReportVM.FromDate=null;
                operationReportVM.ToDate=null;
                operationReportVM.container.operationReportGrid.dataSource.read();
            }

      
            BranchService.getByAction('GetBranchesByUserCompany',true).then(function(response){
                decorateForSelect(response.data);
                operationReportVM.Branches=response.data;
            });

            function decorateForSelect(arrayOfObj) {
                arrayOfObj.forEach(
                    function (obj) {
                        obj.LookupId=obj.CompanyBranchId;
                        obj.VisibleValue = obj.BranchName;
                        obj.HiddenValue = obj.BranchCode;
                    }
                );
            }

            function toggle() {
                $mdSidenav("ExportSideNav")
                    .toggle()
                    .then(function() {});
            }

            operationReportVM.exportToPdf = exportToPdf;

            function search() {
                operationReportVM.container.operationReportGrid.dataSource.read();
                operationReportVM.filterEnabled = true;
                exportLoanApplicationNumber = angular.copy(operationReportVM.LoanApplicationNumber);
                exportBranchId=angular.copy(operationReportVM.BranchId);
                exportNationalId=angular.copy(operationReportVM.NationalId);
                exportFromDate = moment(new Date(operationReportVM.FromDate)).startOf('day').toISOString().replace(/:/g, '~').replace("Z", "");
                exportToDate = moment(new Date(operationReportVM.ToDate)).endOf('day').toISOString().replace(/:/g, '~').replace("Z", "");
      // exportFromDate=angular.copy(operationReportVM.FromDate);
      // exportToDate=angular.copy(operationReportVM.ToDate)
            }

            function exportToPdf() {
                var loanapplicationnumber = exportLoanApplicationNumber
                    ? exportLoanApplicationNumber
                    : null;
                var branchid = exportBranchId
                    ? exportBranchId
                    : null;
                var nationalid = exportNationalId
                    ? exportNationalId
                    : null;
                var offset= -1 * (new Date().getTimezoneOffset());
                var fromdate = exportFromDate && moment(exportFromDate).isValid()
                    ? exportFromDate
                    : null;
                var todate = exportToDate && moment(exportToDate).isValid()
                    ? exportToDate
                    : null;
                OperationReportService.exportOperationReport(loanapplicationnumber,branchid,nationalid,offset,fromdate,todate);
            }
         
            operationReportVM.mainGridOptions = {
                autoBind:false,
                dataSource: {
                    transport: {
                        read: function(o) {                            
                            var loanapplicationnumber = null;
                            var branchid=null;
                            var nationalid=null;
                            var offset=null;
                            var fromdate='';
                            var todate='';


                            if (
                                angular.isUndefined(operationReportVM.LoanApplicationNumber) ||
              (operationReportVM.LoanApplicationNumber == "" ||
                operationReportVM.LoanApplicationNumber == 0)
                            ) {
                                loanapplicationnumber = 0;
                            }
                            else {
                                loanapplicationnumber = operationReportVM.LoanApplicationNumber
                                    ? operationReportVM.LoanApplicationNumber
                                    : null;
                            }

                            if (
                                angular.isUndefined(operationReportVM.BranchId) ||
              (operationReportVM.BranchId == "")) {
                                branchid = 0;
                            } 
                            else {
                                branchid = operationReportVM.BranchId
                                    ? operationReportVM.BranchId
                                    : null;
                            }

                            if (
                                angular.isUndefined(operationReportVM.NationalId) ||
              (operationReportVM.NationalId == "" ||
                operationReportVM.NationalId == 0)
                            ) {
                                nationalid = 0;
                            }
                            else {
                                nationalid = operationReportVM.NationalId
                                    ? operationReportVM.NationalId
                                    : null;
                            }

                            offset= -1 * (new Date().getTimezoneOffset());

                            if (operationReportVM.FromDate) {
                                fromdate = moment(new Date(operationReportVM.FromDate)).startOf('day').toISOString().replace("Z", "");                            
                            }
            // .replace(/:/g, '~')
                            if (operationReportVM.ToDate) {
                                todate = moment(new Date(operationReportVM.ToDate)).endOf('day').toISOString().replace("Z", "");                            
                            }

                            var objArgs = {
                                "LoanApplicationNumber":loanapplicationnumber,
                                "BranchId":branchid,
                                "NationalId":nationalid,
                                "offset":offset,
                                "FromDate":fromdate,
                                "ToDate":todate
                            };
              
                            var filters = {
                                "StoredProcedure": "sp_operation_report",
                                "Arguments": objArgs,
                                "ReportName": "Operation_Report"
                            };

                            operationReportVM.o = angular.copy(o);
                            operationReportVM.filters = operationReportVM.o.data.filter;
                            firebase.logTmxEvent('report',{name:'Operation Report'});
                            OperationReportService.putByParams(o, true, "ReportDataSourceResultPost", filters).then(function (response) {
              
                                if (response) {
                                    operationReportVM.GridResponseData = response.Data;
                                    o.success(response);
                                }
                            });
  
                            operationReportVM.filterEnabled = true;
            
                        },

                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "data.length",
          // parse: function(response) {
          //   if (response != undefined) {
          //     response = response.data;

          //     var invoices = [];
          //     var invoiceNumber = [];

          //     for (var i = 0; i < response.length; i++) {
          //       var invoice = response[i];

          //       invoice.InvoiceGroup =
          //         invoice.InvoiceGroup +
          //         " -- Date:" +
          //         moment(invoice.InvoiceDate).format("DD/MM/YYYY") +
          //         " -- Customer: " +
          //         invoice.CustomerName +
          //         " -- Status: " +
          //         invoice.ClubbedStatus;
          //       invoice.InvoiceDate = moment(invoice.InvoiceDate).format(
          //         "DD-MM-YYYY"
          //       );

          //       if (!invoiceNumber.includes(invoice.InvoiceNumber)) {
          //         invoices.push(invoice);
          //         invoiceNumber.push(invoice.InvoiceNumber);
          //       }
          //     }


          //     invoices = {
          //       data: invoices
          //     };

          //     return invoices;
          //   }
          // }
                    },
        // aggregate: [
        //   { field: "InvoiceNumber", aggregate: "count" },
        //   { field: "InvoiceLineTax", aggregate: "count" },
        //   { field: "InvoiceTotalAmount", aggregate: "sum" }
        // ],
        // group: {
        //   field: "InvoiceNumber",
        //   aggregates: [
        //     { field: "InvoiceNumber", aggregate: "count" },
        //     { field: "InvoiceLineTax", aggregate: "count" },
        //     { field: "InvoiceTotalAmount", aggregate: "sum" }
        //   ]
        // },
                    serverPaging: false,
                    serverFiltering: false,
                    serverSorting: false
        // sort: [{ field: "InvoiceDate", dir: "desc" }]
                },
                pageable: {
                    refresh: true,
                    pageSizes: [5, 10, 15, 20, 100, "All"],
                    pageSize: 15,
                    buttonCount: 4
                },
                excel: {
                    allPages: true,
                    fileName: "OperationReport.xlsx"
                },
                excelExport: function(e) {
                    var sheet = e.workbook.sheets[0];
                    var columns = e.workbook.sheets[0].columns;
                    for (var rowIndex = 1; rowIndex < sheet.rows.length; rowIndex++) {


                        var row = sheet.rows[rowIndex];
          // console.log(row.cells[8].value);
                        if(OperationReportService.showCreator) {
                            row.cells[8].value = operationReportVM.formatDateTime(row.cells[8].value);
                            row.cells[9].value = operationReportVM.formatDateTime(row.cells[9].value);
                        }
                        else {
                            row.cells[8].value = operationReportVM.formatDateTime(row.cells[8].value);
                            row.cells[7].value = operationReportVM.formatDateTime(row.cells[7].value);
                        }
                    }
                    columns.forEach(function(column) {
                        delete column.width;
                        column.autoWidth = true;
                    });
                },
                sortable: true,
                scrollable: !$mdMedia("gt-sm"),

                columns: OperationReportService.GridColumns
            };
        }]);
})();
